@for (item of [].constructor(201); track item; let i = $index) {
  <i class="confetti-{{ i }}"></i>
}
